<template>
    <v-card :title="title" >
        <template slot="extra" v-if="moreUrl">
            <a :href="moreUrl" style="color: #eef0f1">MORE+</a>
        </template>
        <Row id="scroll">
            <Col :sm="24">
                <ul class="list-wrap">
                    <li class="list-item" >
                        <img style="width: 25px;height: 25px;" :src="require('@/assets/hz.jpg')">
                        <div class="left-margin">{{first.substring(0,first.indexOf('@'))}}</div>
                    </li>
                    <li class="list-item" >
                        <span class="item-title" >
                            &nbsp;&nbsp;{{first.substring(first.indexOf('@')+1)}}
                        </span>
                    </li>
                    <div v-for="(items,index) in list">
                        <li class="list-item" >
                            <img style="width: 25px;height: 25px;" :src="require('@/assets/lsdw.jpg')">
                            <div class="left-margin">{{items[0].substring(0,items[0].indexOf('@'))}}</div>
                        </li>
                        <vue-seamless-scroll :class-option="optionStep" :data="items" :class="index===0?'seamless-warp86':'seamless-warp229'">
                            <li class="list-item" v-for="item in items">
                                <div v-if="item" class="item-title">
                                    &nbsp;&nbsp;{{item.substring(item.indexOf('@')+1)}}
                                </div>
                            </li>
                        </vue-seamless-scroll>
                    </div>
                </ul>
            </Col>
        </Row>
    </v-card>
</template>
<style lang="less" scoped>
    @import "../pages/common/mui";
    .seamless-warp229 {
        height: 229px;
        overflow: hidden;
    }
    .seamless-warp86 {
        height: 86px;
        overflow: hidden;
    }
    #scroll{
        top:20px;
        min-height: 250px;
    }
    .left-margin{
        margin-left: 10px;
        color: @color-main;
        font-size: 15px;
    }
    .news-card{
        padding: 8px;
        a.news-img{
            width: 90%;
            margin: 4px auto;
            /*border: 1px solid lightgray;*/
            display: block;

            & img{
                width: 100%;
            }
        }
        & .news-title{
            white-space:nowrap;
            text-overflow:ellipsis;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            color: rgb(82,140,145);
            margin: 6px 0;
        }
        & .news-summary{
            color: #888888;
            height: 96px;
            line-height: 24px;
            overflow: hidden;
        }
        & .news-time{
            color: #888888;
            text-align: right;
            padding-right: 8px;
        }
    }
    .list-wrap{
        list-style: none;
        margin: 8px 0;
        min-height: 330px;
        margin-left: 20px;

        & .list-item{
            height: 30px;
            line-height: 30px;
            display: flex;
            font-size: 14px;
            color: #8A8A8A;

            & .item-title{
                flex: 1;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow: hidden;
                padding-left: 50px;
            }
            & .item-time{
                padding: 0 8px;
            }
        }
    }
</style>
<script>
    import VCard from "./Card";
    export default {
        name:'VNewsScrollCard',
        computed: {
            optionStep () {
                return {
                    step: 0.5
                }
            }
        },
        data() {
            return {
                scrollId:'scroll',
            }
        },
        props:['title','list','first','moreUrl'],
        components: {VCard},
        methods:{
            getHeight(len){
                if(len){
                    return {minHeight:(20*len) + 'px'}
                }
                return {};
            },
        },
        watch:{
            "list":function () {

            }
        }
    }
</script>
